<!-- 自定义翻译弹窗 -->
<template>
  <div class="customTranslateWrap mr-10">
      <el-dropdown trigger="hover" @command="handleCommand">
        <el-button>一键翻译<i class="el-icon-arrow-down el-icon--right"></i></el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item command="a">中文→英文</el-dropdown-item>
          <el-dropdown-item command="b">自定义翻译</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
      <el-dialog
        :visible.sync="visible"
        width="500px"
        title="自定义翻译"
        @closed="handleClosed"
      >
        <div class="translate-form">
          <!-- 源语言 -->
          <el-form :model="formData" label-width="80px" size="medium">
            <el-form-item label="源语言">
              <el-select v-model="formData.sourceLang" placeholder="请选择" style="width: 100%">
                <el-option label="中文" value="zh" />
              </el-select>
            </el-form-item>

            <!-- 目标语言 -->
            <el-form-item label="目标语言">
              <el-select v-model="formData.targetLang" placeholder="请选择" style="width: 100%">
                <el-option v-for="l in targetLangList" :label="l.label" :value="l.value" :key="l.value" />
              </el-select>
            </el-form-item>

            <!-- 翻译内容 -->
            <el-form-item label="翻译内容">
              <div class="content-options">
                <el-checkbox
                  v-model="selectAll"
                  :indeterminate="isIndeterminate"
                  @change="handleSelectAllChange"
                >
                  全选
                </el-checkbox>
                <div class="checkbox-grid">
                  <el-checkbox
                    v-for="item in translateOptions"
                    :key="item.value"
                    v-model="formData.selectedItems"
                    :label="item.value"
                    @change="handleCheckboxChange"
                  >
                    {{ item.label }}
                  </el-checkbox>
                </div>
              </div>
            </el-form-item>
          </el-form>
        </div>

        <span slot="footer">
          <el-button @click="visible = false">取消</el-button>
          <el-button type="primary" @click="() => handleStartTranslate()">开始翻译</el-button>
        </span>
      </el-dialog>
  </div>
</template>

<script>
import { merge,cloneDeep } from 'lodash';
import { translateApi,getLanguages } from '@/api/prod/center/crossBorder.js'
const defaultTargetLangList = [
  { label:'中文',value:'zh' },
  { label:'英语',value:'en' },
  { label:'越南语',value:'vi' },
  { label:'泰语',value:'th' },
  { label:'缅甸语',value:'my' },
  { label:'印度尼西亚语',value:'id' },
  { label:'西班牙语',value:'es' },
]
const defaultTranslateOptions = [
  { label: '商品名称', value: 'productName' },
  // { label: '商品描述', value: 'description' },
  { label: '规格值', value: 'spec' }
]
export default {
  name: 'CustomTranslateDialog',
  props:{
    platform: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      visible: false,
      selectAll: false,
      isIndeterminate: false,
      formData: {
        sourceLang: 'zh',
        targetLang: 'en',
        selectedItems: []
      },
      targetLangList: defaultTargetLangList,
      translateOptions: defaultTranslateOptions
    };
  },
  computed:{
  },
  methods: {
    // 打开弹窗
    open() {
      this.visible = true;
    },
    // 处理一键翻译下拉命令
    handleCommand(command) {
      if (command === 'a') {
        // 中文→英文 快速翻译
        let fields = this.translateOptions.map(item => item.value);
        this.handleStartTranslate('en',fields);
      } else if (command === 'b') {
        // 自定义翻译
        this.open()
      }
    },
    // 处理全选变化
    handleSelectAllChange(checked) {
      if (checked) {
        this.formData.selectedItems = this.translateOptions.map(item => item.value);
      } else {
        this.formData.selectedItems = [];
      }
      this.updateIndeterminateState();
    },

    // 处理单个复选框变化
    handleCheckboxChange() {
      this.updateSelectAllState();
      this.updateIndeterminateState();
    },

    // 更新全选状态
    updateSelectAllState() {
      this.selectAll = this.formData.selectedItems.length === this.translateOptions.length;
    },

    // 更新半选状态
    updateIndeterminateState() {
      const checkedCount = this.formData.selectedItems.length;
      this.isIndeterminate = checkedCount > 0 && checkedCount < this.translateOptions.length;
    },

    // 开始翻译
    handleStartTranslate(targetLang,fields) {
      let keys = fields || this.formData.selectedItems;
      if (keys.length === 0) {
        this.$message.warning('请至少选择一个翻译内容项');
        return;
      }
      const translateFn = (fields,extraParams={}) =>{
        if(!fields || Object.keys(fields).length === 0) {
          this.$message.error('缺少翻译数据，请检查！');
          return;
        }
        let params = {
          shopId:extraParams.shopId || '',
          leafCategoryId:extraParams.leafCategoryId || '',
          targetLanguage:targetLang ||this.formData.targetLang,
          fields:fields
        }
        return new Promise((resolve,reject) => {
          translateApi(params).then(res => {
            if(res.result === 1){
              this.$message.success('翻译成功');
              let d =this.formatData(params.fields,res.data)
              resolve(d);
              // resolve(res.data);
              this.visible = false;
            }else{
              this.$message.error(res.message || '翻译失败');
              reject(err)
            }
          }).catch(err => {
            reject(err)
          })
        });
      }
      this.$emit('confirm',keys,translateFn);
    },
    // 获取翻译语言列表
    getLanguagesList(){
      getLanguages().then(res => {
        if(res.result === 1){
          this.targetLangList = (res.data || []).map(item => ({
            label: item.name,
            value: item.code
          }));
        }
      })
    },
    // 翻译后的特殊字段处理下
    formatData(oldData,newData){
      let formatFields = ['spec']
      let result = newData;
      formatFields.forEach(key => {
        let od = cloneDeep(oldData[key])
        let nd = cloneDeep(newData[key])
        let d = merge(od,nd);
        result[key] = d
      });
      return result;
    },
    // 弹窗关闭后处理
    handleClosed() {
      this.$emit('closed');
    }
  },
  created() {
    this.getLanguagesList()
  }
};
</script>

<style lang="scss" scoped>
.customTranslateWrap{
  display: inline-block;
}
.translate-form {
  padding: 10px 0;

  .content-options {
    width: 100%;

    .checkbox-grid {
      ::v-deep .el-checkbox {
        margin-right: 0;
        height: auto;
        line-height: 1.5;
        margin-right:5px;
      }
    }
  }
}
</style>
